export default function StatusToggle({ value, onChange }) {

  const active = value === "true";

  return (
    <button
      onClick={() => onChange(active ? "false" : "true")}
      className={`px-3 py-1 rounded text-white ${
        active ? "bg-green-600" : "bg-gray-400"
      }`}
    >
      {active ? "Active" : "Inactive"}
    </button>
  );
}